/**
 * Il marchio T2D: i quattro quadrati, senza la scritta.
 *
 * Il file originale (`docs/marchio/logo-t2d.svg`) e' il logo completo, quadrati
 * piu' la scritta "T2D". Qui si usa solo la parte a quadrati, per due motivi:
 *
 *  - accanto c'e' gia' scritto "Assenze T2D". Mettere il logo intero
 *    significherebbe leggere "T2D" due volte a mezzo centimetro di distanza;
 *  - la scritta del file e' grigio chiaro (#dadada), pensata per fondi scuri.
 *    Sulla barra laterale, che e' chiara, sparirebbe.
 *
 * I colori sono quelli del file, non ritoccati: un marchio aziendale non si
 * ricolora di iniziativa. Il grigio chiaro qui e' solo la cornice fra un
 * quadrato e l'altro, e sul fondo chiaro fa da separazione appena accennata,
 * che e' come il marchio e' disegnato.
 *
 * Inline invece che come file importato: sono poche righe, evita una richiesta
 * in piu' all'avvio, e il giorno che servisse adattarlo al tema basta mettere
 * `currentColor` al posto di un colore.
 */
// `| undefined` esplicito: il progetto ha exactOptionalPropertyTypes, e una
// classe letta da un CSS module ha proprio quel tipo.
export function MarchioT2D({ className }: { className?: string | undefined }) {
  return (
    <svg
      className={className}
      viewBox="0 0 140.08 140.08"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="T2D"
    >
      <rect fill="#008e37" x="83.17" y="8.76" width="48.15" height="48.15" />
      <path fill="#dadada" d="M74.42,65.66h65.66V0h-65.66v65.66ZM131.32,56.91h-48.15V8.76h48.15v48.15Z" />
      <rect fill="#152a4c" x="8.75" y="8.76" width="48.15" height="48.15" />
      <path fill="#dadada" d="M0,65.66h65.66V0H0v65.66ZM8.75,8.76h48.15v48.15H8.75V8.76Z" />
      <rect fill="#152a4c" x="83.17" y="83.18" width="48.15" height="48.15" />
      <path fill="#dadada" d="M74.42,140.08h65.66v-65.66h-65.66v65.66ZM83.17,83.18h48.15v48.15h-48.15v-48.15Z" />
      <rect fill="#008e37" x="8.75" y="83.18" width="48.15" height="48.15" />
      <path fill="#dadada" d="M0,140.08h65.66v-65.66H0v65.66ZM8.75,83.18h48.15v48.15H8.75v-48.15Z" />
    </svg>
  );
}
